export class DepositPaymentDTO {
    constructor(
        public id: string,
        public amount: number,
        public currencyCode: string,
        public partySize: number,
        public paymentIntentId: string | null,
        public dateCreated: string,
        public dateRefunded: string | null,
        public amountRefunded: number = 0
    ) { }
}
